import PropTypes from 'prop-types'
import { CalculateSize } from '../CalculateSize'
import { SizeTracker } from '../SizeTracker'
import { Element } from '../html/element'
import { Loading } from '../loading'
import { Notification } from '../notification'
import { TableContent } from './TableContent'

export const Table = ({
  ids,
  getDataFromRedux,
  schema,
  isLoading,
  isNoDataWithHead,
  isStickyFirstCol,
  noDataText,
  isCenterNoData,
  noDataPaddingTop,
  renderTBody,
  renderTHead,
  renderPagination,
  onRowClick,
  isDisplayScroll,
  onRightClick,
  selectedRowId,
  sort,
  changeSort,
  autoHeightMax,
  isSelectNotIn,
  isSetBgTableWithNoData,
  keyReCalculateSize,
  isNoStickyHead,
  isDynamicReport,
  defaultScrollToRight,
}) => {
  const renderContent = (heightMax) => {
    return (
      <>
        {isLoading ? (
          <div className="positionRelative" style={{ height: heightMax }}>
            <Loading />
          </div>
        ) : (
          <TableContent
            ids={ids}
            getDataFromRedux={getDataFromRedux}
            schema={schema}
            isLoading={isLoading}
            isNoDataWithHead={isNoDataWithHead}
            isStickyFirstCol={isStickyFirstCol}
            noDataText={noDataText}
            renderTBody={renderTBody}
            renderTHead={renderTHead}
            onRowClick={onRowClick}
            isDisplayScroll={isDisplayScroll}
            selectedRowId={selectedRowId}
            sort={sort}
            changeSort={changeSort}
            autoHeightMax={heightMax}
            isCenterNoData={isCenterNoData}
            noDataPaddingTop={noDataPaddingTop}
            isSelectNotIn={isSelectNotIn}
            onRightClick={onRightClick}
            isNoStickyHead={isNoStickyHead}
            defaultScrollToRight={defaultScrollToRight}
          />
        )}
      </>
    )
  }

  const renderScroll = (height) => {
    return (
      <CalculateSize height={height} keyChange={keyReCalculateSize}>
        {(size) => {
          return renderContent(size.height)
        }}
      </CalculateSize>
    )
  }

  const renderBottomComponent = () => {
    return ids.length && !isLoading && renderPagination
      ? renderPagination()
      : null
  }

  if (!isNoDataWithHead && ids.length === 0 && !isLoading) {
    return (
      <div className={`h100 ${!isDynamicReport ? 'p1' : ''}`}>
        {isCenterNoData ? (
          <Notification value={noDataText} isDynamicReport={isDynamicReport} />
        ) : (
          <div style={{ paddingTop: noDataPaddingTop }}>
            <Notification
              value={noDataText}
              isDynamicReport={isDynamicReport}
            />
          </div>
        )}
      </div>
    )
  }

  return (
    <Element
      className="wh100 positionRelative"
      style={{
        backgroundColor:
          ids.length === 0 && !isLoading && isSetBgTableWithNoData
            ? '#F3F3F3'
            : 'transparent',
      }}
    >
      {autoHeightMax ? (
        <>
          {renderContent(autoHeightMax)}
          {renderBottomComponent()}
        </>
      ) : (
        <SizeTracker renderBottomComponent={renderBottomComponent}>
          {(size) => {
            return (
              (size.height ||
                (size.height === 0 && !renderBottomComponent())) &&
              renderScroll(`calc(100% - ${size.height}px)`)
            )
          }}
        </SizeTracker>
      )}
    </Element>
  )
}

Table.propTypes = {
  ids: PropTypes.array.isRequired,
  getDataFromRedux: PropTypes.func,
  schema: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  isNoDataWithHead: PropTypes.bool,
  isStickyFirstCol: PropTypes.bool,
  noDataText: PropTypes.string,
  isCenterNoData: PropTypes.bool,
  noDataPaddingTop: PropTypes.number,
  renderTBody: PropTypes.func,
  renderTHead: PropTypes.func,
  renderPagination: PropTypes.func,
  onRowClick: PropTypes.func,
  isDisplayScroll: PropTypes.bool,
  selectedRowId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
  ]),
  onRightClick: PropTypes.func,
  sort: PropTypes.shape({
    sortBy: PropTypes.string,
    sortDirection: PropTypes.string,
  }),
  changeSort: PropTypes.func,
  isSelectNotIn: PropTypes.bool,
  isSetBgTableWithNoData: PropTypes.bool,
  isNoStickyHead: PropTypes.bool,
  isDynamicReport: PropTypes.bool,
  defaultScrollToRight: PropTypes.bool,
}

Table.defaultProps = {
  getDataFromRedux: () => () => {},
  isLoading: false,
  isNoDataWithHead: false,
  isStickyFirstCol: false,
  noDataText: 'common.NO_DATA',
  onRowClick: () => {},
  isDisplayScroll: true,
  onRightClick: () => {},
  isCenterNoData: true,
  noDataPaddingTop: 80,
  isSelectNotIn: false,
  isSetBgTableWithNoData: false,
  isNoStickyHead: false,
  defaultScrollToRight: false,
}
